import { createSingleRaceFeed, createChoiceLookup } from './stores.js';
import { sharedRaceFile } from './shared-races.js';
import {
  findElementByIdInShadowDom,
  renderSvelteComponent,
} from './utils/render.js';
import ResultsBar from './components/ResultsBar.svelte';

async function main() {
  const container = findElementByIdInShadowDom('hp-mayor-results');
  if (!container) return;

  // follows scripts/shared-races.js
  const [raceId, source] = sharedRaceFile('CA-84303');
  const mayorRace = await createSingleRaceFeed(raceId, source);

  // AP and L.A. Vote use different candidate ids
  const [bass, raman] =
    source === 'lavote'
      ? ['karen-ruth-bass', 'nithya-raman']
      : ['50853', '172807'];

  const crosswalk = window.CROSSWALK.assets.img;

  renderSvelteComponent(ResultsBar, container, {
    race: mayorRace,
    candidate1: bass,
    candidate2: raman,
    candidateLookup: createChoiceLookup(mayorRace),
    crosswalk,
    hp: true,
  });
}

main().catch(console.error);
